import { render, staticRenderFns } from "./PolicyCoverLimits.vue?vue&type=template&id=7500fa2e&"
import script from "./PolicyCoverLimits.vue?vue&type=script&lang=js&"
export * from "./PolicyCoverLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports